import { PublishContent } from '@storeOld/reducers/publish'
import cx from 'classnames'
import type React from 'react'

import css from './PreviewBlock.module.scss'

type Props = {
  contentType: PublishContent
  bgWhite: boolean
  children: React.ReactNode
}

export const PreviewBlock: React.FC<Props> = ({
  contentType,
  bgWhite,
  children,
}) => (
  <div
    className={cx(css.previewBlock, {
      [css.islands]: contentType === PublishContent.ISLANDS,
      [css.bgWhite]: bgWhite,
    })}
  >
    {children}
  </div>
)
